export const fetchSection = (url) =>
  fetch(url)
    .then((res) => res.text())
    .then((html) =>
      new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(".shopify-section")
    );

class CollectionCarousel extends HTMLElement {
  constructor() {
    super()

    this.swiper = false
    this.config = JSON.parse(this.dataset.config)

    this.selectors = {
      swiper: '.swiper',
      prev: '[data-carousel-prev]',
      next: '[data-carousel-next]',
      products: '[data-carousel-products]',
      dropdown: '[data-carousel-dropdown]',
      pagination: '[data-carousel-pagination]',
      scrollbar: '[data-carousel-scrollbar]'
    }

    this.initialise()
  }

  initialise() {
    this.buildCarousel()

    const dropdown = this.querySelector(this.selectors.dropdown)
    if (dropdown) {
      dropdown.addEventListener('change', this.onDropdownChange.bind(this))
    }
  }

  getCollectionInfo(id) {
    return this.config.blocks.find(
      (block) => block.collection.id === Number(id)
    )
  }

  async onDropdownChange(e) {
    const selectedValue = e.target.value;
    if (!selectedValue) return;

    this.loading = true;

    const block = this.getCollectionInfo(selectedValue);
    await this.loadProducts(block);

    this.loading = false;
  }

  async loadProducts(block) {
    return fetchSection(
      `/collections/${block.collection.handle}?section_id=collection-carousel-products&show_oos=${block.show_oos}&product_count=${block.product_count}`
    ).then((section) => {
      
      this.destroyCarousel();
      
      this.querySelector(this.selectors.products).innerHTML = section.innerHTML;
      
      this.buildCarousel();
    })
  }

  buildCarousel() {
    if (this.swiper) {
      this.destroyCarousel()
    }

    const carouselConfig = {
      slidesPerView: 1.1,
      spaceBetween: 15,
      navigation: {
        nextEl: this.querySelector(this.selectors.next),
        prevEl: this.querySelector(this.selectors.prev)
      },
      pagination: {
        el: this.querySelector(this.selectors.pagination),
        type: 'bullets',
        clickable: true,
        dynamicBullets: true,
      },
      scrollbar: {
        el: this.querySelector(this.selectors.scrollbar),
        snapOnRelease: true,
        draggable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 15
        },
        990: {
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 15
        },
        1280: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 15
        },
        1550: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 15
        },
        1800: {
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 15
        },
        2000: {
          slidesPerView: 8,
          slidesPerGroup: 8,
          spaceBetween: 15
        },
      }
    }

    this.swiper = new Swiper(
      this.querySelector(this.selectors.swiper),
      carouselConfig
    )
  }

  destroyCarousel() {
    if (this.swiper) {
      this.swiper.destroy(true, true)
      this.swiper = false
    }
  }

  set loading(val) {
    this.classList.toggle('loading', val)
  }
}

if (!customElements.get('collection-carousel')) {
  customElements.define('collection-carousel', CollectionCarousel)
}